import classes from "./Button.module.css";

const Button = (props) => {
  // Optional fullWidth behavior (defaults to true to preserve existing usages)
  const fullWidth = props.fullWidth !== undefined ? props.fullWidth : true;

  // Compose className, adding disabled variants when needed
  const cls = [
    classes.btn,
    props.disabled ? classes.btnDisabled : "",
    classes.btnBox,
    props.disabled ? classes.btnBoxDisabled : "",
    fullWidth ? classes.btnLarge : "",
    classes.btnAfter,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      className={[cls, props.className].filter(Boolean).join(" ")}
      data-icon="arrow_forward"
      disabled={props.disabled}
      style={props.style}
    >
      <b>{props.text}</b>
    </button>
  );
};

export default Button;
